import { useState } from "react";

import { ActivationComponentAssets } from "app/pages/activation/helpers/ActivationAssets";

export const useAISetup = () => {
    const [isAIInputFocused, setIsAIInputFocused] = useState(false);
    const AiCompetitorsEnabled = ActivationComponentAssets.isAiCompetitorsEnabled;

    const handleAIInputFocus = () => {
        setIsAIInputFocused(true);
    };

    const handleAIInputBlur = () => {
        setIsAIInputFocused(false);
    };

    return {
        isAIInputFocused,
        handleAIInputFocus,
        handleAIInputBlur,
        AiCompetitorsEnabled,
    };
};
